import { render, staticRenderFns } from "./MenuBar.vue?vue&type=template&id=59a78be7&scoped=true&"
import script from "./MenuBar.vue?vue&type=script&lang=ts&"
export * from "./MenuBar.vue?vue&type=script&lang=ts&"
import style0 from "./MenuBar.vue?vue&type=style&index=0&id=59a78be7&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59a78be7",
  null
  
)

export default component.exports